import { Analysis, PossibleRootCauseCategory } from '.';

export class ElectrolytesAnalysis extends Analysis{
    calculateInsights() {
        if (this.ba.sodium.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_9000);
        } else if (this.ba.sodium.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_9010);
        }

        if (this.ba.potassium.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_9020);
        } else if (this.ba.potassium.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_9030);
        }

        if (this.ba.sodiumPotassiumRatio.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_9032);
        } else if (this.ba.sodiumPotassiumRatio.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_9034);
        }

        if (this.ba.chloride.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_9040);
        } else if (this.ba.chloride.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_9050);
        }

        if (this.ba.carbonDioxide.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_9060);
        } else if (this.ba.carbonDioxide.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_9070);
        }

        if (this.ba.anionGapWithoutK.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_9080);
        } else if (this.ba.anionGapWithoutK.isOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_9090);
        } else if (this.ba.anionGapWithoutK.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_9100);
        }

        if (this.ba.anionGap.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_9110);
        } else if (this.ba.anionGap.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_9120);
        }
    }
}